import { createFileRoute, useNavigate, redirect } from '@tanstack/react-router';
import { DeckGroupForm } from '@/components/DeckGroupForm';
import { useCreateDeckGroup } from '@/queries/deck-groups';
import { BackgroundWaves } from '@/components/BackgroundWaves';
import type { CreateDeckGroupRequest, UpdateDeckGroupRequest } from '@/types/deck-group';
import styles from '../quiz-page.module.scss';

export const Route = createFileRoute('/quizlets/deck-groups/create')({
  component: CreateDeckGroup,
  beforeLoad: ({ context }) => {
    const { user, authLoading } = context as { user: any; authLoading: boolean };
    if (authLoading) return;
    if (!user) {
      throw redirect({ to: '/' });
    }
  },
});

function CreateDeckGroup() {
  const navigate = useNavigate();
  const createDeckGroup = useCreateDeckGroup();

  const handleSave = async (data: CreateDeckGroupRequest | UpdateDeckGroupRequest) => {
    await createDeckGroup.mutateAsync(data as CreateDeckGroupRequest);
  };

  const handleCancel = () => {
    navigate({
      to: '/quizlets',
      search: { tab: 'grouped' },
    });
  };

  return (
    <div className={styles.quizPage}>
      <BackgroundWaves />

      <div className={styles.quizPage__breadcrumb}>
        <nav className={styles.quizPage__nav}>
          <a
            href="/quizlets?tab=grouped"
            className={styles.quizPage__link}
            onClick={(e) => {
              e.preventDefault();
              navigate({
                to: '/quizlets',
                search: { tab: 'grouped' },
              });
            }}
          >
            Grouped Decks
          </a>
          <span className={styles.quizPage__separator}>›</span>
          <span className={styles.quizPage__current}>Create Grouping</span>
        </nav>
      </div>

      <DeckGroupForm
        onSave={handleSave}
        onCancel={handleCancel}
        isLoading={createDeckGroup.isPending}
        error={createDeckGroup.error?.message}
      />
    </div>
  );
}
